module.exports = __webpack_public_path__ + "img/hangouts.24fc119a.svg";